import * as React from "react";
import { StickyCallToAction } from "@grandvisionhq/common";
import { FramesCTA } from "../../../../../../FramesCTA/modules/EcommContent/FramesEcommContent/components/FramesCTA/FramesCTA.js";
import { useFramesEcommContext } from "../../../../../../../context/modules/EcommContent/FramesEcommContent/context/FramesEcommContext.js";
import { useFramesPriceFrom } from "../../../../../../../hooks/modules/EcommContent/FramesEcommContent/hooks/use-frames-price-from.js";
import { StickyPriceView } from "../../../../../../../../../StickyCta/components/modules/StickyCta/components/StickyPriceView.js";
const FramesStickyCTA = ({ className }) => {
  const { displayPrice } = useFramesEcommContext();
  const { fromPricePrefix } = useFramesPriceFrom();
  return /* @__PURE__ */ React.createElement(
    StickyCallToAction,
    {
      className,
      button: /* @__PURE__ */ React.createElement(FramesCTA, null),
      price: /* @__PURE__ */ React.createElement(StickyPriceView, { displayPrice, prefix: fromPricePrefix })
    }
  );
};
export {
  FramesStickyCTA
};
//# sourceMappingURL=FramesStickyCTA.js.map
